import React from 'react';
import AppLayout from '../../components/AppLayout';
import OverviewList from '../../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,AddListItem,
        Segment,LoadGraphic,Step,DynamicListArea,BulkEdit} from '../../components/Common';
import {Input,Button,Area, PageSelector, MiniMinusButton, Checkbox, TextButton} from '../../components/Input';
import u from '../../utilities/Utilities';
import moment from 'moment';

export default class ItemSupplierList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Item Supplier",
        permission:"inventory",  //Accepts combined permission module as well
        //combinedField:"price",     //Used when permission exists in a combined field
        url:"/item-supplier-list",

        /**** Action Setup ****/
        addType:1,
        addURL:"/api/add-item-supplier-entry",
        //templateURL:"/api/get-add-tenant-template",
        //bulkURL:"/api/add-bulk-tenants",
        deleteURL:"/api/delete-item-supplier-entries",
        spreadsheetURL:"/api/generate-item-supplier-spreadsheet",
        overviewURL:"/api/get-all-item-supplier-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"item-supplier-list",
        orderByField:"createdOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        add:{component:AddEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
        options:{},
        storeItems:[],
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions(this.settings.permission);
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (bulkEditOptions.length > 0 && (permissions.update));
        this.setState({
            pageMenuButtons:[
                {label:"Add Entry",ref:"add",enabled:(permissions.delete)},
                {label:"Delete Entries",ref:"delete",enabled:(permissions.delete)},
                {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
                {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
            ],
            permissions:permissions,
        });

        this.getStoreItems();
    }

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    }

    getStoreItems=async ()=>{
        try{
            const response=await u.postAsync({
                url:"/api/get-active-store-items",
                data:{}
            });
            this.setState({storeItems:response.data});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    render=()=>{
        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>
                <div className="page-error-container">
                    <div className="page-error">{this.state.error}</div>
                </div>

                <PageMenu buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}
                          />

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <ListItem key={index}
                                              index={index}
                                              content={content}
                                              onChange={onChange}
                                              onContentChange={onContentChange}
                                              registerReference={registerRef}
                                              options={this.state.options}
                                              settings={this.settings}
                                              permissions={this.state.permissions}
                                              storeItems={this.state.storeItems}
                                              />
                            )
                        }
                    }
                    
                </OverviewList>
            </AppLayout>
        )
    }
}

class ListItem extends React.Component{

    r={};

    pageLength = 10;

    state={
        step:"view",
        error:"",
        loading:false,
        loadText:"",
        page:1,
        startIndex:0,
        endIndex:this.pageLength,
        updateOptions:[],
    }

    static getDerivedStateFromProps(props,state){
        const maxPage = Math.ceil(props.content.approvedItemList.length/10);

        if(props.content.listID != state.listID){
            state.listID=props.content.listID;
            state.startIndex=0;
            state.endIndex=10;
            state.page=1;
        }

        if(state.page > maxPage){
            state.page = maxPage;
            state.startIndex = (maxPage-1)*10;
            state.endIndex=state.startIndex + 10;
        }
        
        return state;
    }
    
    onChangePage=(newPage)=>{
        const startIndex = (newPage-1) * this.pageLength;
        const endIndex = startIndex + this.pageLength;
        this.setState({page:newPage,startIndex:startIndex,endIndex:endIndex});
    }

    onRemoveItem=(index)=>{
        const {content}=this.props;
        this.onRemoveConfirm=async ()=>{
            try{
                this.setState({loading:true,loadText:"Removing..."});
                await u.postAsync({
                    url:"/api/remove-supplier-item",
                    data:{
                        itemSupplierID:content.listID,
                        remove:content.approvedItemList[index]
                    }
                });
                content.approvedItemList.splice(index,1);
                this.props.onChange(content.approvedItemList,"approvedItemList",this.props.index);
                this.setState({step:"view",error:"",loading:false});
            }
            catch(e){
                const {error,status}=u.processError(e);
                this.setState({error:error,loading:false});
            }
        }
        this.setState({
            remove:content.approvedItemList[index],
            step:"remove",
        });
    }

    onUpdateRequest=()=>{
        const {storeItems,content}=this.props;
        let options = JSON.parse(JSON.stringify(storeItems));
        options.map((item)=>{
            item.selected = (content.approvedItemList.filter((approved)=>{
                return approved.itemID == item.itemID;
            }).length > 0);

            return item;
        });
        this.setState({updateOptions:options,step:"add",error:""});
    }

    onChangeUpdateOptions=(updateOptions)=>{
        this.setState({updateOptions:updateOptions});
    }

    onUpdateApproved=async ()=>{
        let {content}=this.props;

        let newApprovedItemList = this.state.updateOptions.filter((item)=>{
            return item.selected
        });

        try{
            this.setState({loading:true,loadText:"Updating..."});
            await u.postAsync({
                url:"/api/update-supplier-approved-list",
                data:{
                    itemSupplierList:content.listID,
                    approvedItemList:newApprovedItemList,
                }
            });
            this.props.onChange(newApprovedItemList,"approvedItemList",this.props.index);
            this.setState({step:"view",error:"",loading:false});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
    }

    render=()=>{
        const {content,options,settings,onChange,permissions} = this.props;
        const {page,startIndex,endIndex,loading,loadText,step,updateOptions}=this.state;
        const canEdit=(permissions.delete==2);
        const maxPage=Math.ceil(content.approvedItemList.length/this.pageLength);

        return (
            <div>
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="list-segment-error">{this.state.error}</div>
                <Step active={step == "view"}>
                    <DynamicListArea content={content}
                                     onChange={onChange}
                                     index={this.props.index}
                                     listLabel={settings.listLabel}
                                     permission={settings.permission}
                                     bypassPermission={canEdit}
                                     />
                    
                    {
                        (content.approvedItemList.length > 0)
                            ?
                            <div className='list-table' style={{maxHeight:"none",marginTop:"30px"}}>
                                <h3>Approved Item List</h3>
                                <table>
                                    <thead>
                                        <tr>
                                            <th className='remove left'/>
                                            <th style={{width:"200px"}}>Item Code</th>
                                            <th>Item</th>
                                            <th style={{width:"150px"}} className='right'>Quantifier</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            content.approvedItemList.map(
                                                (item,index)=>{
                                                    if(index<startIndex || index>=endIndex){
                                                        return null;
                                                    }
                                                    return (
                                                        <tr key={index}>
                                                            <td className='remove'>{(index+1)}.</td>
                                                            <td>{item.itemCode}</td>
                                                            <td>{item.itemName}</td>
                                                            <td>{item.purchaseQuantifier}</td>
                                                        </tr>
                                                    )
                                                }
                                            )
                                        }
                                    </tbody>
                                </table>
                                {
                                    (maxPage > 1)
                                        ?
                                        <div style={{margin:"20px auto"}}>
                                            <PageSelector maxPage={maxPage}
                                                          page={page}
                                                          onChange={this.onChangePage}
                                                          />
                                        </div>
                                        :
                                        null
                                }
                            </div>
                            :
                            <div className='list-placeholder'>
                                <b>No Approved Items</b>
                                <div>Click below to add approved items</div>
                            </div>
                    }

                    <div style={{margin:"30px auto",textAlign:"center"}}>
                        {
                            (canEdit)
                                ?
                                <TextButton onClick={this.onUpdateRequest}>Update Approved Item</TextButton>
                                :
                                null
                        }
                    </div>
                </Step>

                <Step active={step == "remove"}>
                    <div style={{position:"relative",padding:"30px 0",textAlign:"center"}}>
                        <h2 className='text-negative'>Confirm remove {this.state.remove?.itemName} from approved list?</h2>
                        <div className='list-segment-note'>
                            Note. This change will not affect existing Purchase Orders
                        </div>
                        <div style={{margin:"20px auto"}}>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={()=>{this.onRemoveConfirm()}}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={step=="add"}>
                    <div style={{position:"relative",padding:"20px 0",textAlign:"center"}}>
                        <h2>Select items that are approved for this supplier</h2>
                        
                        <ApproveItemSelect options={updateOptions}
                                           onChange={this.onChangeUpdateOptions}
                                           />

                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onUpdateApproved}>Confirm</Button>
                        </div>
                    </div>
                </Step>
            </div>
        )
    }
}

class ApproveItemSelect extends React.Component{

    pageLength=10;

    state={
        page:1,
        startIndex:0,
        endIndex:this.pageLength,
    }

    onChangePage=(newPage)=>{
        const startIndex = (newPage-1) * this.pageLength;
        const endIndex = startIndex + this.pageLength;
        this.setState({page:newPage,startIndex:startIndex,endIndex:endIndex});
    }

    onSelectAll=(value)=>{
        let {options}=this.props;
        options=options.map((item)=>{
            item.selected=value;
            return item;
        });
        this.props.onChange(options);
    }

    onChange=(value,label,index)=>{
        let {options}=this.props;
        options[index].selected=value;
        this.props.onChange(options);
    }

    render=()=>{
        const {options}=this.props;
        const {page,startIndex,endIndex}=this.state;
        const maxPage = Math.ceil(options.length / this.pageLength);

        if(options.length == 0){
            return (
                <div className='list-placeholder'>
                    <b>No Items Available</b>
                    <div>Please create item in Store Page</div>
                </div>
            )
        }

        return (
            <div>
                <div className='list-table' style={{maxHeight:"none"}}>
                    <table>
                        <thead>
                            <tr>
                                <th className='remove left'>
                                    <Checkbox values={{
                                                value:(options.filter((item)=>{return item.selected}).length == options.length)
                                            }}
                                            onChange={this.onSelectAll}
                                            label="Select All"
                                            />
                                </th>
                                <th style={{width:"200px"}}>Item Code</th>
                                <th>Item</th>
                                <th className='right' style={{width:"150px"}}>Quantifier</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                options.map(
                                    (item,index)=>{
                                        if(index<startIndex || index>=endIndex){
                                            return null;
                                        }
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <Checkbox values={{value:item.selected}}
                                                            index={index}
                                                            label="Selected"
                                                            field="selected"
                                                            onChange={this.onChange}
                                                            />
                                                </td>
                                                <td>{item.itemCode}</td>
                                                <td>{item.itemName}</td>
                                                <td>{item.purchaseQuantifier}</td>
                                            </tr>
                                        )
                                    }
                                )
                            }
                        </tbody>
                    </table>
                </div>
                {
                    (maxPage>1)
                        ?
                        <div style={{margin:"30px auto"}}>
                            <PageSelector maxPage={maxPage}
                                        page={page}
                                        onChange={this.onChangePage}
                                        />
                        </div>
                        :
                        null
                }
            </div>
        )
    }
}

class AddEntry extends React.Component{
    r={};

    settings={
        addType:0,
        addURL:"/api/add-item-supplier-entry",
    }

    state={
        step:"view",
        entryData:{},
    }

    show=(show)=>{
        this.r[this.props.reference].show(show);
        if(!show){
            this.setState({error:""});
        }
    }

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onConfirm=(fields)=>{
        const keys = fields.map((item)=>{return item.field});
        let data = {};
        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                const current=this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]]=current.value;
            }
        }
        this.r[this.props.reference].onValidated(data);
    }

    onComplete=()=>{
        this.setState({
            entryData:{},
            step:"view"
        });
    }

    render=()=>{
        const {loading,loadText,step}=this.state;
        const fields=[
            {dataType:"box",label:"Company Name",field:"companyName",rules:{required:true}},
            {dataType:"box",label:"Supplier Code",field:"code",rules:{required:true}},
            {dataType:"box",label:"POC Name",field:"pocName",rules:{placeholder:"Optional"}},
            {dataType:"contactNumber",label:"Contact No",contactNumberField:"contactNumber",countryCodeField:"countryCode",rules:{placeholder:"Optional"}},
            {dataType:"box",label:"Address",field:"address",rules:{placeholder:"Optional"}},
            {dataType:"box",label:"Postal Code",field:"postalCode",rules:{placeholder:"Optional"}},
            {dataType:"box",label:"Email",field:"email",type:"email",rules:{placeholder:"Optional"}},
        ];

        return (
            <AddListItem ref={(ref)=>{this.r[this.props.reference]=ref}}
                         reference={this.props.reference}
                         settings={this.settings}
                         onComplete={this.onComplete}
                         uploadAsJson={true}
                         onToggleForm={this.props.onToggleForm}
                         >
                <div className='segment-content'>
                    <LoadGraphic active={loading} text={loadText}/>
                    <Step active={step=="view"}>
                        <h3>Complete the following fields to continue</h3>
                        {
                            fields.map(
                                (item,index)=>{
                                    return (
                                        <Input key={index}
                                               ref={(ref)=>{this.r[item.field]=ref}}
                                               values={{options:item.options}}
                                               fields={item}
                                               rules={item.rules}
                                               labelStyle={{width:"40%"}}
                                               inputStyle={{width:"57%"}}
                                               />
                                    )
                                }
                            )
                        }
                        <div style={{margin:"20px auto",fontSize:"14px"}}>
                            Note. Approved items can be updated after the supplier entry is created
                        </div>
                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={this.onCancel}>Cancel</Button>
                            <Button onClick={()=>{this.onConfirm(fields)}}>Confirm</Button>
                        </div>
                    </Step>
                </div>
            </AddListItem>
        )
    }
}
